import { foundationBadgeStyles } from '@genesislcap/foundation-ui';
import { designUnit } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
import { chartPinkWebRGBA, primaryBlueWebRGBA, secondaryTealWebRGBA, } from '../_config/styles/colors';
export const zeroBadgeStyles = (context, definition) => css `
  ${foundationBadgeStyles(context, definition)}
  :host {
    --badge-fill-primary: ${primaryBlueWebRGBA()};
    --badge-fill-secondary: ${secondaryTealWebRGBA()};
    --badge-fill-pink: ${chartPinkWebRGBA()};
    --badge-fill-transparent: transparent;
    --badge-color-black: #000;
    --badge-color-white: #fff;
  }

  :host .control {
    padding: calc(${designUnit} * 1px) calc(${designUnit} * 2px);
  }
`;
